// components\ImageGallery.tsx

import React from 'react';
import purchaseIcon from '../assets/purchase.png'; // 구매 아이콘 경로
import naverIcon from '../assets/naverShop.jpg'; // 구매 아이콘 경로
import coupangIcon from '../assets/coupangShop.png'; // 구매 아이콘 경로
import cafe24Icon from '../assets/cafe24Shop.png'; // 구매 아이콘 경로
import githubIcon from '../assets/github.png'; // 구매 아이콘 경로
import './ImageGallery.css'; // 스타일 파일을 추가로 불러옵니다.
import image1 from '../assets/i2r-01.jpg'; // 이미지 경로
import image2 from '../assets/i2r-02.jpg'; // 이미지 경로
import image3 from '../assets/i2r-03.jpg'; // 이미지 경로
import image4 from '../assets/i2r-04.jpg'; // 이미지 경로
import image5 from '../assets/i2r-05.png'; // 이미지 경로
import image6 from '../assets/i2r-shield-1.png'; // 이미지 경로
import image7 from '../assets/i2r-04-motor.png'; // 이미지 경로

const images = [
  {
    id: 'i2r-01',
    src: image1,
    name: 'RS232, RS485, WiFi, BLE 통신모듈 [i2r-01]',
    description: '와이파이, 블루투스, RS232, RS485 를 조합해서 사용 입력전압: 5~30V',
    link: 'https://smartstore.naver.com/i2r/products/8284829279?nl-query=i2r-01&nl-au=eb56af0a6d2d498d9972ee19b05578b6&NaPm=ci%3Deb56af0a6d2d498d9972ee19b05578b6%7Cct%3Dmfq4bt7x%7Ctr%3Dnslsl%7Csn%3D424830%7Chk%3Df9ed22359bfa1787233dc5fa1f77f6f77384df22',
    linkCoupang: 'https://www.coupang.com/vp/products/9042380453?itemId=26532060292&vendorItemId=93506173178&q=9042380453&searchId=d54a46776326473&sourceType=search&itemsCount=10&searchRank=1&rank=1&traceId=mfq38o5j',
    linkCafe24: 'https://i2rlink.cafe24.com/shop3/product/detail.html?product_no=15&item_code=P000000P000C&utm_medium=product_shelf&utm_source=youtube&yt_act=20250919110846',
    linkGithub: 'https://github.com/kdi6033/i2r-01'
  },
  {
    id: 'i2r-02',
    src: image2,
    name: 'IoT PLC (4채널 릴레이) [i2r-02]',
    description: '와이파이 블루투스 통신을 이용해 2접점 릴레이 제어 입력전압: 5~30V, 30A 릴레이 1개, 10A 릴레이 3개',
    link: 'https://smartstore.naver.com/i2r/products/8285060920?nl-query=i2r-02&nl-au=5d200a8f4f714ae79ef01fbbc554788a&NaPm=ci%3D5d200a8f4f714ae79ef01fbbc554788a%7Cct%3Dmfq4azkd%7Ctr%3Dnslsl%7Csn%3D424830%7Chk%3Db59950f252aa4727e58a3e69f1a503f7d429b111',
    linkCoupang: 'https://www.coupang.com/vp/products/8752533658?itemId=25445455918&vendorItemId=93506172998&q=8752533658&searchId=1cf2f8281164065&sourceType=search&itemsCount=10&searchRank=1&rank=1&traceId=mfq3f0wv',
    linkCafe24: 'https://i2rlink.cafe24.com/shop3/product/detail.html?product_no=13&item_code=P000000N000D&utm_medium=product_shelf&utm_source=youtube&yt_act=20250919110249',
    linkGithub: 'https://github.com/kdi6033/i2r-02'
  },
  {
    id: 'i2r-03',
    src: image3,
    name: 'IoT PLC (4채널 릴레이) [i2r-03]',
    description: '와이파이 블루투스 통신을 이용해 3접점 릴레이 제어, 온도 습도 센서 내장, 입력전압: 5~30V, 30A 릴레이 1개, 10A 릴레이 3개',
    link: 'https://smartstore.naver.com/i2r/products/8285011211?nl-query=i2r-03&nl-au=f797719442b744eaada6f697e8970b05&NaPm=ci%3Df797719442b744eaada6f697e8970b05%7Cct%3Dmfq49wij%7Ctr%3Dnslsl%7Csn%3D424830%7Chk%3D25b2927db25be1ac6559c5235e885ce68992a140',
    linkCoupang: 'https://www.coupang.com/vp/products/8753606053?itemId=25448139310&vendorItemId=93506172994&q=8753606053&searchId=655a4bb76596720&sourceType=search&itemsCount=1&searchRank=0&rank=0&traceId=mfq3gyzo',
    linkCafe24: 'https://i2rlink.cafe24.com/shop3/product/detail.html?product_no=14&item_code=P000000O000B&utm_medium=product_shelf&utm_source=youtube&yt_act=20250919110142',
    linkGithub: 'https://github.com/kdi6033/i2r-03'
  },
  {
    id: 'i2r-04',
    src: image4,
    name: 'IoT PLC (8채널 릴레이) [i2r-04]',
    description: '와이파이 블루투스 통신을 이용해 3접점 릴레이 제어 입력전압: 5~30V, 10A 릴레이 8개',
    link: 'https://smartstore.naver.com/i2r/products/9524935681?nl-query=i2r-04&nl-au=a257f532b6744444b190acff5cdb4200&NaPm=ci%3Da257f532b6744444b190acff5cdb4200%7Cct%3Dmfq48gw9%7Ctr%3Dnslsl%7Csn%3D424830%7Chk%3De2d57c7ecb43bc36d287ea0986f16bf5d96b6261',
    linkCoupang: 'https://www.coupang.com/vp/products/8753613193?itemId=25448185673&vendorItemId=93506172976&q=8753613193&searchId=288fb3741185089&sourceType=search&itemsCount=10&searchRank=1&rank=1&traceId=mfq3j8bc',
    linkCafe24: 'https://i2rlink.cafe24.com/shop3/product/detail.html?product_no=12&item_code=P000000M000C&utm_medium=product_shelf&utm_source=youtube&yt_act=20250919110019',
    linkGithub: 'https://github.com/kdi6033/i2r-04'
  },
  {
    id: 'i2r-05',
    src: image5,
    name: 'Arduino ESP32-S3 AI IoT Edge 컨트롤러 [i2r-05]',
    description: 'ESP32-S3 기반의 IoT AI Arduino 보드, 다양한 스마트 디바이스 및 제어 시스템에 활용할 수 있습니다.',
    link: 'https://smartstore.naver.com/i2r/products/11698644965?nl-query=i2r-05&nl-au=8cc0270ec7b8410db004ad919efde87b&NaPm=ci%3D8cc0270ec7b8410db004ad919efde87b%7Cct%3Dmfq47i7q%7Ctr%3Dnslsl%7Csn%3D424830%7Chk%3D230e968e5951d540aed0ae9330406fa09c25b34f',
    linkCoupang: 'https://www.coupang.com/vp/products/9042380454?itemId=26532060305&vendorItemId=93506172909&q=9042380454&searchId=84aec1c51306049&sourceType=search&itemsCount=6&searchRank=1&rank=1&traceId=mfq3lwe0',
    linkCafe24: 'https://i2rlink.cafe24.com/shop3/product/detail.html?product_no=20&item_code=P000000U000E&utm_medium=product_shelf&utm_source=youtube&yt_act=20250919105931',
    linkGithub: 'https://github.com/kdi6033/i2r-05'
  },
  {
    id: 'i2r-shield-1',
    src: image6,
    name: 'AI IoT Arduino Shield [i2r-shield-1]',
    description: '아두이노 확장 보드, 온도 습도 아나로그 IR 스위치 LED 모듈 확장 보드',
    link: 'https://smartstore.naver.com/i2r/products/11747502715?nl-query=i2r%20shield&nl-au=c326372ffb11476a9e15f4e89b48517c&NaPm=ci%3Dc326372ffb11476a9e15f4e89b48517c%7Cct%3Dmfq46gdl%7Ctr%3Dnslsl%7Csn%3D424830%7Chk%3Da15a3fe78c24983ca6783a76cc7810eb7adb2df8',
    linkCoupang: 'https://www.coupang.com/vp/products/9042380416?itemId=26532060032&vendorItemId=93506172925&q=9042380416&searchId=050effb7893781&sourceType=search&itemsCount=1&searchRank=0&rank=0&traceId=mfq3oasf',
    linkCafe24: 'https://i2rlink.cafe24.com/shop3/product/detail.html?product_no=21&item_code=P000000V000A&utm_medium=product_shelf&utm_source=youtube&yt_act=20250919105744',
    linkGithub: 'https://github.com/kdi6033/i2r-05?tab=readme-ov-file#1-i2r-05-shield-v1-%EB%B3%B4%EB%93%9C'
  },
  {
    id: 'i2r-04-motor',
    src: 'https://github.com/kdi6033/i2r-04/raw/main/images/i2r-04-hmi-kc.png?raw=true',
    name: 'IoT PLC 모터제어 [i2r-04-motor]',
    description: '모터 제어 보드, 조도센서 연동, 작동시간 설정, Edge AI 모듈 연동',
    link: 'https://smartstore.naver.com/i2r/products/12416774129?nl-query=i2r-04-motor&nl-au=369f43cb79814f0ea88e67cbb3d93cd2&NaPm=ci%3D369f43cb79814f0ea88e67cbb3d93cd2%7Cct%3Dmfq3yest%7Ctr%3Dnslsl%7Csn%3D424830%7Chk%3Da6e19aba18c618ea1d754ad37fa4d803c53e3173',
    linkCoupang: '',
    linkCafe24: 'https://i2rlink.cafe24.com/shop3/product/detail.html?product_no=22&item_code=P000000W000A&utm_medium=product_shelf&utm_source=youtube&yt_act=20250919105421',
    linkGithub: 'https://github.com/kdi6033/i2r-04'
  },
  {
    id: 'i2r-02-hmi',
    src: 'https://github.com/kdi6033/i2r-02/raw/main/images/i2r-02-hmi-kc.png',
    name: 'IoT PLC 터치 컨트롤러 [i2r-02-hmi]',
    description: '와이파이 블루투스 통신을 이용해 2접점 릴레이 제어 입력전,압: 5~30V, 30A 릴레이 1개, 10A 릴레이 3개',
    link: 'https://smartstore.naver.com/i2r/products/12913667191',
    linkCoupang: '',
    linkCafe24: '',
    linkGithub: 'https://github.com/kdi6033/i2r-02'
  },
  {
    id: 'i2r-03-hmi',
    src: 'https://github.com/kdi6033/i2r-03/raw/main/images/i2r-03-hmi-kc.png?raw=true',
    name: 'IoT PLC 터치 컨트롤러 [i2r-03-hmi]',
    description: '와이파이 블루투스 통신을 이용해 3접점 릴레이 제어, 온도 습도 센서 내장 입력전압: 5~30V, 30A 릴레이 1개, 10A 릴레이 3개',
    link: 'https://smartstore.naver.com/i2r/products/12913255448',
    linkCoupang: '',
    linkCafe24: '',
    linkGithub: 'https://github.com/kdi6033/i2r-03'
  },
  {
    id: 'i2r-04-hmi',
    src: 'https://github.com/kdi6033/i2r-04/raw/main/images/i2r-04-hmi-kc.png?raw=true',
    name: 'IoT PLC 터치 컨트롤러 [i2r-04-hmi]',
    description: '와이파이 블루투스 통신을 이용해 3접점 릴레이 제어 입력전압: 5~30V, 10A 릴레이 8개',
    link: 'https://smartstore.naver.com/i2r/products/12906158652',
    linkCoupang: '',
    linkCafe24: '',
    linkGithub: 'https://github.com/kdi6033/i2r-04'
  }
];

const iotPlcProducts = images.filter(img => ['i2r-02', 'i2r-03', 'i2r-04', 'i2r-04-motor', 'i2r-02-hmi', 'i2r-03-hmi', 'i2r-04-hmi'].includes(img.id));
const sensorProducts = images.filter(img => ['i2r-shield-1'].includes(img.id));
const physicalAiProducts = images.filter(img => ['i2r-01', 'i2r-05'].includes(img.id));

const ProductSection: React.FC<{
  title: React.ReactNode;
  description: React.ReactNode;
  products: typeof images;
}> = ({ title, description, products }) => {
  return (
    <div className="product-section">
      <div className="product-section-header">
        {title}
      </div>
      <div className="product-description-container">
        {description}
      </div>
      <div className="image-gallery">
        {products.map((image, index) => (
          <div key={index} className="image-container">
            <img src={image.src} alt={image.name} className="image" />
            <div className="image-name">{image.name}</div>
            <div className="image-description">
              {image.description}
            </div>
            <div className="image-link">
              {image.link && (
                <a href={image.link} target="_blank" rel="noopener noreferrer" style={{ marginRight: '5px' }}>
                  <img src={naverIcon} alt="구매" className="purchase-icon" style={{ width: '70px' }} />
                </a>
              )}
              {image.linkCoupang && (
                <a href={image.linkCoupang} target="_blank" rel="noopener noreferrer" style={{ marginRight: '5px' }}>
                  <img src={coupangIcon} alt="구매" className="purchase-icon" style={{ width: '70px' }} />
                </a>
              )}
              {image.linkCafe24 && (
                <a href={image.linkCafe24} target="_blank" rel="noopener noreferrer" style={{ marginRight: '5px' }}>
                  <img src={cafe24Icon} alt="구매" className="purchase-icon" style={{ width: '70px' }} />
                </a>
              )}
              {image.linkGithub && (
                <a href={image.linkGithub} target="_blank" rel="noopener noreferrer">
                  <img src={githubIcon} alt="깃허브" className="purchase-icon" style={{ width: '70px' }} />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const ImageGallery: React.FC = () => {
  return (
    <div style={{ padding: '20px', backgroundColor: '#fff' }}>
      <ProductSection
        title={
          <>
            <span className="icon">🔷</span> 1. IoT PLC (Physical · On-Device AI · Edge Controller Lineup)
          </>
        }
        description={
          <ul className="product-description-list">
            <li>산업 현장에서 사용되는 <span className="highlight-text">ESP32 기반 IoT PLC / Physical AI Controller</span> 라인업입니다.</li>
            <li>센서 입력부터 판단, 출력 제어까지를 하나의 장치에서 처리하는 <span className="highlight-text">Edge 제어 시스템</span>을 제공합니다.</li>
            <li>모든 보드는 <span className="highlight-text">Wi-Fi, Bluetooth, MQTT</span> 통신을 기본 지원하며,</li>
            <li>센서와 기기 간의 실시간 연동을 통해 <span className="highlight-text">입력(Sensor) → 판단(AI) → 출력(Control)</span> 이 현장에서 즉시 수행됩니다.</li>
          </ul>
        }
        products={iotPlcProducts}
      />

      <ProductSection
        title={
          <>
            <span className="icon">🔷</span> 2. IoT Sensor · Actuator (Physical World Interface)
          </>
        }
        description={
          <ul className="product-description-list">
            <li>IoT PLC 및 Edge Controller와 연동되어</li>
            <li>물리 세계의 상태를 <span className="highlight-text">실시간으로 수집(Sensor)</span> 하거나</li>
            <li>실제 동작을 <span className="highlight-text">직접 수행(Actuator)</span> 하는 장치 및 기술 계층입니다.</li>
            <li>온·습도, CO₂, 조도, 전압, 전류 등 다양한 센서 데이터를 안정적으로 수집하고,</li>
            <li>수집된 데이터는 <span className="highlight-text">On-Device AI를 통해 현장에서 즉시 분석·판단</span>되어</li>
            <li>PLC 또는 액추에이터 제어로 바로 연결됩니다.</li>
          </ul>
        }
        products={sensorProducts}
      />

      <ProductSection
        title={
          <>
            <span className="icon">🔷</span> 3. Physical AI & On-Device Control (Communication · Edge Node · Arduino Platform)
          </>
        }
        description={
          <ul className="product-description-list">
            <li>IoT PLC를 구성하고 확장하기 위한 <span className="highlight-text">Physical AI 및 On-Device 제어 기술 플랫폼</span>입니다.</li>
            <li>ESP32 및 Arduino 기반 보드를 활용하여 센서 데이터 처리, 통신, AI 판단, 장치 제어를 <span className="highlight-text">클라우드 의존 없이 현장(Edge)에서 직접 구현</span>할 수 있도록 설계되었습니다.</li>
            <li><span className="highlight-text">입력(Sensor) → 판단(AI) → 출력(Control)</span> 이 하나의 연속된 Edge 제어 루프로 동작하며, UI 기반 설정을 통해 <span className="highlight-text">코드 작성 없이(No-Code)</span> 센서 조건과 제어 규칙을 구성할 수 있습니다.</li>
          </ul>
        }
        products={physicalAiProducts}
      />
    </div>
  );
};

export default ImageGallery;
